import { FC } from 'react';
import { ImageFile } from '@features/DemandFormTemplates/model/DemandForm';
import { useDocumentPreview } from '@components/DocumentPreviewDialog/useDocumentPreview';
import styles from './UploadForm.module.scss';

interface IImageFileTagProps {
  file: (ImageFile | File)[];
  className?: string;
}

/**
 * @param props - The props for the component.
 * @param file - file to show name.
 * @param className - class for file tag container.
 * @returns A React component that displays an file tag.
 */

const ImageFileTag: FC<IImageFileTagProps> = (props) => {
  const { file, className } = props;
  const { openPreview, previewDialog } = useDocumentPreview();
  return (
    <>
      <div
        className={[className || styles.filename].join(' ')}
        onClick={() => {
          if ((file as any).url) {
            // ZLAYT-1445: in-app preview, not a new tab on the storage URL.
            openPreview((file as any).url, (file as any).name);
          }
        }}
      >
        <img src="/icons/file-text.svg" />
        {(file as any).name}
        <span />
      </div>
      {previewDialog}
    </>
  );
};

export { ImageFileTag };
